import React from "react";
import ReactDOM from "react-dom/client";
import './App.css';
import './index.css';
import App from "./App";
import { registerSW } from 'virtual:pwa-register';

registerSW({ immediate: true } as any);

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
root.render(<App/>);